<template lang="pug">
.new-user
  shForm(title="Nuevo Usuario")
</template>

<script>
import shForm from '@/components/pages/user/Form'

export default {
  name: 'NewUser',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-user
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/user/New.vue